import { ReactElement } from "react";

/* both brand faces (New Spirit + Lato) as plain CSS — see the note at the top of fonts.css for why not createGlobalStyle */
require("./src/styles/fonts.css");

import * as React from "react";
import RootLayout from "./src/components/layout/RootLayout";
import { GatsbyBrowser, ShouldUpdateScrollArgs } from "gatsby";
import { keepPillsInPlace } from "./src/components/shop/productsCategoryPage/SubcategoryNav";
import { isOurHost, redirectTarget } from "./src/utils/functions/originGuard";

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (!isOurHost(window.location.hostname)) {
    window.location.replace(redirectTarget);
  }
};

interface Props {
  element: ReactElement;
}

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }: Props) => {
  return <RootLayout>{element}</RootLayout>;
};

export const shouldUpdateScroll = ({ routerProps: { location } }: ShouldUpdateScrollArgs) => keepPillsInPlace(location.state);
